import { useCallback, useState } from "react";
import { CaseAppealsTableRowData } from "../../../../data-model/caseAppealsTable";
import {
  AppealInfoFormData,
  buildAppealInfoInitialData,
} from "../utils/buildAppealInfoInitialData";

/** Keys used in {@link AppealInfoFormData} for typed field updates. */
export enum AppealInfoDataKeys {
  APPEAL_TYPE = "appealType",
  APPEAL_STATUS = "appealStatus",
  APPEAL_REASON = "appealReason",
  APPEAL_COMMENTS = "appealComments",
}

/**
 * Manages Appeal Info modal form state with optional row prefill.
 *
 * @param initialData - Table row or API record used to seed the form
 * @returns Form state, change handler, and save-readiness flag
 */
export const useAppealInfoData = (
  initialData?: CaseAppealsTableRowData | null,
) => {
  const [appealInfoData, setAppealInfoData] = useState<AppealInfoFormData>(() =>
    buildAppealInfoInitialData(initialData),
  );

  const handleAppealInfoDataChange = useCallback(
    (field: keyof AppealInfoFormData, value: string) => {
      setAppealInfoData((prev) => ({
        ...prev,
        [field]: value,
      }));
    },
    [],
  );

  const isSaveEnabled =
    appealInfoData.appealType.trim() !== "" &&
    appealInfoData.appealStatus.trim() !== "";

  return {
    appealInfoData,
    handleAppealInfoDataChange,
    isSaveEnabled,
  };
};
